function disableButton(btn) {
    btn.disabled = true;
    btn.style.opacity = '0.6';
    btn.style.cursor = 'not-allowed';
}

function enableButton(btn) {
    btn.disabled = false;
    btn.style.opacity = '1';
    btn.style.cursor = 'pointer';
}

function handleGoogleSso(event) {
    const btn = event.currentTarget;
    disableButton(btn);

    const backendUrl = btn.dataset.backendUrl || window.location.origin;
    const redirectTo = encodeURIComponent(`${backendUrl}/sso/google/session`);

    fetch(`${backendUrl}/api/auth/google?redirect_to=${redirectTo}`)
        .then(response => response.json())
        .then(data => {
            if (data.url) {
                window.location.href = data.url;
            } else {
                console.error('No URL returned from SSO endpoint');
                alert('Failed to initiate Google sign-in');
                enableButton(btn);
            }
        })
        .catch(error => {
            console.error('SSO error:', error);
            alert('Failed to initiate Google sign-in');
            enableButton(btn);
        });
}

function initGoogleSsoButton() {
    const btn = document.getElementById('google-sso-btn');
    if (!btn) {
        return;
    }

    btn.addEventListener('click', handleGoogleSso);
}

document.addEventListener('DOMContentLoaded', initGoogleSsoButton);
